
/**
 * Wait `ms` time.
 * Can be used to postpone any operations to test "long" async requests
 * @param {*} ms time to postpone. default 3000 ms
 * @returns {Promise<void>}
 */
async function sleep(ms = 3000) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default sleep;
